import type { StaticImageData } from 'next/image';
import Image from 'next/image';
import emptyStateImageBaseMobile from '@/public/assets/image/global-states/empty/default/empty-default-state-mobile.webp';
import emptyStateImageBase from '@/public/assets/image/global-states/empty/default/empty-default-state.webp';
import { cn } from '@/utils/cn';

type EmptyStateVisualProps = {
  className?: string;
  mobileImageClassName?: string;
  classNameGradient?: string;
  desktopImageClassName?: string;
  mobileSrc?: StaticImageData;
  desktopSrc?: StaticImageData;
};

const EmptyStateVisual = ({
  className,
  mobileImageClassName,
  classNameGradient,
  desktopImageClassName,
  mobileSrc = emptyStateImageBaseMobile,
  desktopSrc = emptyStateImageBase,
}: EmptyStateVisualProps) => (
  <div className={cn('relative', className)}>
    <div
      className={cn('absolute top-3.25 lg:top-14.25 lg:rotate-[-14deg] lg:left-5.25 blur-[1.875rem] left-4 w-35 h-35 lg:w-62.5 lg:h-30 rounded-full opacity-80 pointer-events-none bg-main-back-gradient', classNameGradient)}
    />
    <Image
      src={mobileSrc}
      alt="Empty state"
      className={cn('w-42.25 h-41.5 relative z-10 block lg:hidden mb-3.75', mobileImageClassName)}
      width={280}
      height={280}
    />

    <Image
      src={desktopSrc}
      alt="Empty state"
      className={cn('w-67.5 h-auto mb-3.75 mr-5.25 relative z-10 hidden lg:block', desktopImageClassName)}
      width={630}
      height={600}
    />
  </div>
);

export default EmptyStateVisual;
